import React from 'react';
import { Link } from 'react-router-dom';

export default function RbacRolePermissionsPage() {
  return (
    <div className="dashboard-main-body">
      <div className="alert alert-info">
        Los permisos ya no se editan en una matriz global. Cada feature administra sus roles,
        permisos y scopes desde su propia plantilla.
      </div>
      <Link className="btn btn-primary" to="/features">Abrir Features</Link>
    </div>
  );
}
